import { gql } from '@apollo/client'

export const SERIES_SUMMARY = gql`
  fragment SeriesSummaryFragment on Series {
    primaryValue
    primaryCode
    seriesTotal
    seriesTotalUnweighted
  }
`

export const SERIES_WITH_SUMMARY_FRAGMENT = gql`
  fragment SeriesWithSummaryFragment on Series {
    primaryValue
    primaryCode
    seriesTotal
    seriesTotalUnweighted
    dataPoints {
      unweighted
      verbatims {
        text
        tags {
          key
          value
        }
        primaryValue
      }
    }
    __typename
  }
`
export const SERIES_DETAILS_NO_LIMIT = gql`
  fragment SeriesDetailsFragmentNoLimit on Series {
    ...SeriesSummaryFragment
    aggregateDataPoint {
      percent
      unweighted
      secondaryValue
      secondaryCode
      weighted
    }
    answerCode
    dataPoints {
      percent
      unweighted
      secondaryValue
      secondaryCode
      weighted
    }
  }
  ${SERIES_SUMMARY}
`

export const SERIES_DETAILS = gql`
  fragment SeriesDetailsFragment on Series {
    ...SeriesSummaryFragment
    aggregateDataPoint(limit: $limitDataPoints) {
      percent
      unweighted
      secondaryValue
      secondaryCode
      weighted
    }
    dataPoints(limit: $limitDataPoints) {
      percent
      marketShare
      unweighted
      secondaryValue
      secondaryCode
      weighted
      weightedTotal
      unweightedTotal
      average
    }
  }
  ${SERIES_SUMMARY}
`

export const SERIES_RATING_DETAILS = gql`
  fragment SeriesRatingDetailsFragment on Series {
    ...SeriesSummaryFragment
    aggregateDataPoint(limit: $limitDataPoints) {
      percent
      unweighted
      secondaryValue
      secondaryCode
      weighted
    }
    dataPoints(limit: $limitDataPoints) {
      average
      unweighted
      secondaryValue
      secondaryCode
      weighted
      weightedTotal
      unweightedTotal
    }
  }
  ${SERIES_SUMMARY}
`
export const SERIES_RATING_TREND_DETAILS = gql`
  fragment SeriesRatingTrendDetailsFragment on Series {
    ...SeriesSummaryFragment
    aggregateDataPoint(limit: $limitDataPoints) {
      percent
      average
      unweighted
      secondaryValue
      secondaryCode
      weighted
    }
    dataPoints(limit: $limitDataPoints) {
      percent
      average
      unweighted
      secondaryValue
      secondaryCode
      weighted
      weightedTotal
      unweightedTotal
    }
  }
  ${SERIES_SUMMARY}
`
export const SERIES_DETAILS_AVERAGE = gql`
  fragment SeriesDetailsAverageFragment on Series {
    ...SeriesSummaryFragment
    aggregateDataPoint(limit: $limitDataPoints) {
      unweighted
      secondaryValue
      weighted
    }
    dataPoints(limit: $limitDataPoints) {
      unweighted
      secondaryValue
      average
      weighted
    }
  }
  ${SERIES_SUMMARY}
`
export const AGGREGATE_DETAILS = gql`
  fragment AggregateDetailsFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesDetailsFragment
    }
    series(limit: $limitSeries, chartType: $chartType) {
      ...SeriesDetailsFragment
    }
    totalItems
  }
  ${SERIES_DETAILS}
`
export const AGGREGATE_RATING_TREND_DETAILS = gql`
  fragment AggregateRatingTrendDetailsFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesRatingTrendDetailsFragment
    }
    series(limit: $limitSeries) {
      ...SeriesRatingTrendDetailsFragment
    }
    totalItems
  }
  ${SERIES_RATING_TREND_DETAILS}
`

export const AGGREGATE_RATING_DETAILS = gql`
  fragment AggregateRatingDetailsFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesRatingDetailsFragment
    }
    series(limit: $limitSeries) {
      ...SeriesRatingDetailsFragment
    }
    totalItems
  }
  ${SERIES_RATING_DETAILS}
`
export const AGGREGATE_DETAILS_AVERAGE = gql`
  fragment AggregateDetailsAverageFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesDetailsAverageFragment
    }
    series(limit: $limitSeries) {
      ...SeriesDetailsAverageFragment
    }
    totalItems
  }
  ${SERIES_DETAILS_AVERAGE}
`

export const AGGREGATE_DETAILS_NO_SERIES_LIMIT = gql`
  fragment AggregateDetailsNoSeriesLimitFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesDetailsFragment
    }
    series {
      ...SeriesDetailsFragment
    }
    totalItems
  }
  ${SERIES_DETAILS}
`
export const AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY = gql`
  fragment AggregateDetailsFragmentNoLimitNoSummary on AggregateWithoutSummary {
    totalCount
    totalCountUnweighted
    series {
      ...SeriesDetailsFragment
    }
    totalItems
  }
  ${SERIES_DETAILS}
`

export const AGGREGATE_DETAILS_WITH_SUMMARY = gql`
  fragment AggregateDetailsWithSummaryFragment on AggregateWithSummary {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesWithSummaryFragment
      __typename
    }
    totalItems
    __typename
  }
  ${SERIES_WITH_SUMMARY_FRAGMENT}
`

export const AGGREGATE_DETAILS_NO_DATA_LIMIT = gql`
  fragment AggregateDetailsNoLimitFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesDetailsFragmentNoLimit
    }
    series {
      ...SeriesDetailsFragmentNoLimit
    }
  }
  ${SERIES_DETAILS_NO_LIMIT}
`

export const SUMMARY_SERIES_DETAILS = gql`
  fragment SummarySeriesDetailsFragment on Aggregate {
    totalCount
    totalCountUnweighted
    summarySeries {
      ...SeriesDetailsFragment
    }
  }
  ${SERIES_DETAILS}
`

export const AGGREGATE_DETAILS_NO_SUMMARY = gql`
  fragment AggregateDetailsFragmentNoSummary on AggregateWithoutSummary {
    totalCount
    totalCountUnweighted
    series(limit: $limitSeries) {
      ...SeriesDetailsFragment
    }
    totalItems
  }
  ${SERIES_DETAILS}
`
